import { defineStore } from 'pinia'
import { useThemeStore } from './theme'
import { usePersistedStore } from './persisted'
import { useShowCaseStore } from './showcase'
import { convertArrayToObject } from 'src/utils'
import { usePersistedLocalStore } from './persisted-local'
import { reloadPage } from 'src/utils'
import { NotifyMethods } from 'src/boot/notify'
import { Platform } from 'quasar'
import { isSsr, appConfig } from 'src/constants'

export const useCommonStore = defineStore('common', {
  state: () => ({
    appLoaded: false,
    isFirstPage: false,
    businessConfigurations: {},
    // shippingConfigurations: null,
    businessFulfillments: {},
    allFulfillments: {},
    fulFillmentLocations: {},
    backHistories: [],
    trendingProducts: {},
    frequentSearches: [],
    defaultHeaderParams: {
      categoryButton: true,
      logo: true,
      changeLocationButton: true,
      searchBar: true,
      accountButton: true,
      favoriteButton: true,
      cartButton: true,
      reserveTimeSlotButton: true,
      offerDealsButton: false,
      backButton: false,
      homeButtom: false,
      searchButton: false,
      title: '',
    },
    headerInfo: {},
    alertData: {
      variant: 'danger',
      showCountDown: 0,
      message: '',
    },
    NetworkConnectionStatus: 1,
    footerData: null,
    socialPlatforms: null,
    // storeActive: false,
    tenantFound: false,
    storeConfigurationLoaded: false,
    clientStoreConfigurationLoaded: false,
    storeIsActive: false,
    mobileAppData: null,
    askFullAddressForDelivery: false,
    isFulfillmentInactive: false,
    // homePageSwiperWidth: 1200,
    showPWAInstallPopup: false,
    showPWAInstallPopupSidebar: false,
    paymentServiceLogoLoaded: false,
    paymentServiceLogos: [],
    showDateTimeBehindError: false,
    showDateTimeAheadError: false,
    lnsLoaded: false,
    disclaimers: [],
    announcements: [],
    currentRoute: null,
    windowDimensions: {
      width: 0,
      height: 0,
    },
    policyData: null,
  }),
  getters: {
    forceUserToEnterZipCode() {
      // if (rootGetters['persisted/isProceedLocation']) return false
      return (
        this.businessConfigurations &&
        this.businessConfigurations.forceUserToEnterZipCode
      )
    },
    header() {
      return Object.keys(this.headerInfo).length
        ? this.headerInfo
        : this.defaultHeaderParams
    },
    backRoute() {
      return this.backHistories.length
        ? this.backHistories[this.backHistories.length - 1]
        : null
    },
    networkStatus() {
      return this.NetworkConnectionStatus
    },
    currentDeliveryModes() {
      const persistedStore = usePersistedStore()
      let deliveryModes = {
        isStorePickup: false,
        isStandardDelivery: false,
        isScheduledDelivery: false,
      }

      let selectedFulfillmentCodeName =
        persistedStore.selectedFulfillmentCodeName || ''

      switch (selectedFulfillmentCodeName) {
        case 'sp':
          deliveryModes.isStorePickup = true
          break
        case 'sd':
          deliveryModes.isStandardDelivery = true
          break
        case 'scd':
          deliveryModes.isScheduledDelivery = true
          break
      }

      return deliveryModes
    },
    checkSlotBookingRequired() {
      return (fulfillmentCode, forceCheck = false) => {
        const persistedStore = usePersistedStore()
        const selectedFulfillment =
          persistedStore.selectedFulfillmentCodeName || ''

        if (fulfillmentCode !== selectedFulfillment && !forceCheck) {
          return false
        }

        const targetFulfillment =
          this.fulFillmentLocations[fulfillmentCode] || {}
        const { available, configuration } = targetFulfillment

        return (
          available &&
          !configuration?.isComingSoon &&
          configuration?.isSlotBookingRequired
        )
      }
    },
    isSlotBookingRequired() {
      const persistedStore = usePersistedStore()
      const selectedFulfillmentCodeName =
        persistedStore.selectedFulfillmentCodeName || ''
      const { available, configuration } =
        this.fulFillmentLocations[selectedFulfillmentCodeName] || {}

      return (
        available &&
        !configuration?.isComingSoon &&
        configuration?.isSlotBookingRequired
      )
    },
    enableOfferTag() {
      return this.businessConfigurations?.enableOfferTag || false
    },
    showTrendingCategory() {
      return this.businessConfigurations?.showTrendingCategory || false
    },
    currentPaymentGateway() {
      return this.businessConfigurations.currentPaymentGateway || 'DATACAP'
    },
    storeHasLnsSubscription() {
      return this.businessConfigurations?.lnsSubscriptionType === 2
    },
    commonStateByKey() {
      return (field) => this[field]
    },
  },
  actions: {
    async getFooterData() {
      try {
        let { data } = await this.$axiosInstance.get('/FooterDetails', {
          params: {
            global: true,
          },
        })

        if (data?.data) this.setState({ key: 'footerData', value: data.data })
      } catch (error) {}
    },
    async getConfiguration() {
      const themeStore = useThemeStore()
      const persistedStore = usePersistedStore()
      const isServer = process.env.SERVER,
        loadSsrConf = isSsr && isServer

      try {
        let response, url

        if (loadSsrConf) url = '/v2/Configuration'
        else url = '/v1/Configuration'

        // if (loadSsrConf && false) {
        //   response = await new Promise((res) => {
        //     return res({
        //       data: {
        //         data: {
        //           businessConfigurationID: '41a686e2-92b0-4847-8b88-4abfb84715a3',
        //           businessName: 'Smokers Choice USA',
        //           isActive: true,
        //           mode: 0,
        //           modeDescription: '',
        //           isStoreAgeRestricted: false,
        //           enableAgeRestrictedBrowsing: false,
        //           enableAgeRestrictedCheckout: false,
        //           fulfillments: [
        //             {
        //               fulfillmentID: '81c89b19-8f64-4cb9-b1c3-8ad12b0135e4',
        //               businessID: '41a686e2-92b0-4847-8b88-4abfb84715a3',
        //               fulfillmentName: 'Store Pickup',
        //               codeName: 'sp',
        //               isActive: true,
        //               infoForCustomer:
        //                 '<div style="text-align: left;"><b style="text-align: center; font-size: 14px; letter-spacing: 0.25004px;">Description For Users Added By Admin</b></div>',
        //               pickupInfo:
        //                 '<div style="text-align: center;"><b style="font-size: 14px; letter-spacing: 0.25004px;">Store Pickup Instruction Added By Admin</b></div>',
        //               minOrderAmount: 100,
        //               fixedFee: 10,
        //               slotClosingDays: 0,
        //               slotClosingHours: 0,
        //               slotClosingMinutes: 0,
        //               slotClosingTimeInMin: 0,
        //               isSlotBookingRequired: true,
        //               isComingSoon: false,
        //               enableRescheduleOrder: true,
        //               deliveryMethod: 0,
        //               deliveryCoverageBy: 0,
        //               isTipEnabled: true,
        //               tipOption1: 1,
        //               tipOption2: 2,
        //               tipOption3: 3,
        //               tipOption4: 4,
        //               isSignatureRequired: false,
        //             },
        //             {
        //               fulfillmentID: '88c78724-6158-4b63-9019-3fc16f5e6c4a',
        //               businessID: '41a686e2-92b0-4847-8b88-4abfb84715a3',
        //               fulfillmentName: 'Delivery',
        //               codeName: 'scd',
        //               isActive: true,
        //               infoForCustomer:
        //                 'Delivery&nbsp;<span style="font-size: 14px; letter-spacing: 0.25004px;">Description for Users 222</span>',
        //               pickupInfo: null,
        //               minOrderAmount: 0,
        //               fixedFee: 0,
        //               slotClosingDays: 0,
        //               slotClosingHours: 0,
        //               slotClosingMinutes: 0,
        //               slotClosingTimeInMin: 0,
        //               isSlotBookingRequired: true,
        //               isComingSoon: false,
        //               enableRescheduleOrder: false,
        //               deliveryMethod: 1,
        //               deliveryCoverageBy: 0,
        //               isTipEnabled: true,
        //               tipOption1: 10,
        //               tipOption2: 25,
        //               tipOption3: 35,
        //               tipOption4: 40,
        //               isSignatureRequired: true,
        //             },
        //             {
        //               fulfillmentID: '1cb3c275-93e7-45c6-9410-b8b07c99003f',
        //               businessID: '41a686e2-92b0-4847-8b88-4abfb84715a3',
        //               fulfillmentName: 'Standard Shipping',
        //               codeName: 'sd',
        //               isActive: true,
        //               infoForCustomer:
        //                 '<span style="font-size: 14px; letter-spacing: 0.25004px;">Standard Shipping Description for Users333</span>',
        //               pickupInfo: '',
        //               minOrderAmount: 0,
        //               fixedFee: 0,
        //               slotClosingDays: 0,
        //               slotClosingHours: 0,
        //               slotClosingMinutes: 0,
        //               slotClosingTimeInMin: 0,
        //               isSlotBookingRequired: false,
        //               isComingSoon: false,
        //               enableRescheduleOrder: false,
        //               deliveryMethod: 0,
        //               deliveryCoverageBy: 0,
        //               isTipEnabled: false,
        //               tipOption1: 0,
        //               tipOption2: 0,
        //               tipOption3: 0,
        //               tipOption4: 0,
        //               isSignatureRequired: false,
        //             },
        //           ],
        //           tenantAcr: 'ftx.dev.ftxcommerce.com',
        //           accountID: '5acdfce1-c19d-4ebf-9b26-6de6cb440be7',
        //           logoURL:
        //             'https://ftx-online-ordering-images.s3.amazonaws.com/OnlineOrder/backend-images/1d4b115c-8505-43bd-a369-94b42d604b75_202404150825166159.png',
        //           defaultProductImageURL: null,
        //           betaImageUrl:
        //             'https://ftx-online-ordering-images.s3.amazonaws.com/OnlineOrder/backend-images/1d4b115c-8505-43bd-a369-94b42d604b75_202404150825166159.png',
        //         },
        //         success: true,
        //         message: 'success',
        //         instance: null,
        //         developerMessage: null,
        //         errors: null,
        //       },
        //       status: 200,
        //       statusText: '',
        //     })
        //   })
        // } else {
        response = await this.$axiosInstance.get(url, {
          params: {
            global: true,
          },
          useCache: false,
        })
        // }

        if (response?.data) {
          let { data } = response,
            {
              businessConfigurations,
              fulfillments,
              socialPlatforms,
              // shippingConfigurations,
              tenantAcr,
              accountID,
            } = data.data

          if (loadSsrConf) {
            businessConfigurations = data.data

            let themeData = {
              logoURL: businessConfigurations.logoURL,
              defaultProductImageURL:
                businessConfigurations.defaultProductImageURL,
              betaImageUrl: businessConfigurations.betaImageUrl,
            }
            themeStore.setTheme(themeData)
          }

          if (!tenantAcr)
            tenantAcr = appConfig.TENANT_ACR.replace('tenant:', '')
          // businessFulfillments = []

          // for (let fulfillment of fulfillments) {
          //   businessFulfillments.push({ ...fulfillment, model: true })
          // }

          // if (tenantAcr) this.$oidc._settings._acr_values = tenantAcr
          this.setState({
            key: 'businessConfigurations',
            value: {
              ...businessConfigurations,
              tenantAcr,
              accountID,
            },
          })
          // Set Mode Details
          if ([0, 1, 2, 3].includes(businessConfigurations?.mode)) {
            let activeMode = persistedStore.activeMode
            if (activeMode !== businessConfigurations.mode)
              persistedStore.validateAccessCode(false)
            persistedStore.setActiveMode(businessConfigurations.mode)
            if (activeMode == 1 && activeMode != businessConfigurations.mode)
              reloadPage()
          }
          this.setState({
            key: 'businessFulfillments',
            value: convertArrayToObject(
              fulfillments.filter((fulfillment) => fulfillment.isActive),
              'codeName'
            ),
          })
          this.setState({
            key: 'allFulfillments',
            value: convertArrayToObject(fulfillments, 'codeName'),
          })

          if (!loadSsrConf) {
            this.setState({
              key: 'socialPlatforms',
              value: socialPlatforms || null,
            })
          }
          this.setState({ key: 'tenantFound', value: true })

          this.setState({
            key: 'storeIsActive',
            value: businessConfigurations && businessConfigurations.isActive,
          })
          this.setState({
            key: 'storeConfigurationLoaded',
            value: true,
          })
          if (!loadSsrConf) {
            this.setState({
              key: 'clientStoreConfigurationLoaded',
              value: true,
            })
          }
        }

        return response
      } catch (error) {
        this.setState({
          key: 'storeConfigurationLoaded',
          value: true,
        })

        if (!loadSsrConf) {
          this.setState({
            key: 'clientStoreConfigurationLoaded',
            value: true,
          })
        }
      }
    },
    async getMobileAppData() {
      const showCaseStore = useShowCaseStore()
      const persistedLocalStore = usePersistedLocalStore()
      try {
        let { data } = await this.$axiosInstance.get('/MobileApp', {
          params: {
            global: true,
          },
        })
        if (data && data.data && data.data.url) {
          this.setState({ key: 'mobileAppData', value: data.data })
          persistedLocalStore.setField({
            key: 'showAppDownloadNotification',
            value: false,
          })

          NotifyMethods.showAppDownloadNotify(() => {
            if (Platform?.is?.mobile)
              window.open(data.data.url, '_blank').focus()
            else
              showCaseStore.updateDialogState({
                dialog: 'AppBarcode',
                val: true,
              })
          })
        }
      } catch (error) {}
    },
    async validateAccessCode({ mode, code }) {
      try {
        let response
        if (mode == 2)
          response = await this.$axiosInstance.post('/Mode/Test', {
            accessCode: code,
          })
        else if (mode == 3)
          response = await this.$axiosInstance.post('/Mode/Beta', {
            accessCode: code,
          })

        if (response.data) return response.data
      } catch (error) {
        return error
        // if (error.errors[0].errorCode == 'CONFIGRATION_NOT_FOUND')
        //   return error.errors[0]
        // else return false
      }
    },
    async checkDeliveryAddressForLocations() {
      try {
        let response = await this.$axiosInstance.get(
          '/Configuration/Locations',
          {
            params: {
              global: true,
            },
          }
        )
        if (response?.data && response?.data?.success)
          setState({
            key: 'askFullAddressForDelivery',
            value: response?.data?.data?.askFullAddressForDelivery || false,
          })
      } catch (error) {
        return false
      }
    },
    async getDisclaimer() {
      const showCaseStore = useShowCaseStore()
      const persistedLocal = usePersistedLocalStore()
      try {
        let disclaimerUpdate = persistedLocal.disclaimerUpdate

        let { data } = await this.$axiosInstance.get('/Disclaimer', {
          params: {
            disablePaging: true,
          },
        })

        let disclaimers = data?.data?.items || []

        if (disclaimers?.length) {
          this.setState({
            key: 'disclaimers',
            value: disclaimers,
          })

          let hasUnReadDisclaimers = false
          // if (!Object.keys(disclaimerUpdate).length) {
          //   hasUnReadDisclaimers = true
          // } else
          disclaimers.every((disclaimer) => {
            if (
              disclaimer.isRequiredAcceptance &&
              (!disclaimerUpdate?.hasOwnProperty(disclaimer.id) ||
                (disclaimerUpdate?.hasOwnProperty(disclaimer.id) &&
                  disclaimerUpdate[disclaimer.id] != disclaimer.updatedAt))
            ) {
              hasUnReadDisclaimers = true
              return false
            }

            return true
          })

          if (hasUnReadDisclaimers) {
            let parentDialog = showCaseStore.getDialogState(
              'AnnouncementDialog'
            )
              ? 'AnnouncementDialog'
              : null
            showCaseStore.updateDialogState({
              dialog: 'DisclaimerDialog',
              val: true,
              parentDialog,
            })
          }
        }
        return data
      } catch (error) {
        return error
      }
    },
    async getAnnouncement() {
      const persistedLocalStore = usePersistedLocalStore()
      const persistedStore = usePersistedStore()
      const showCaseStore = useShowCaseStore()
      try {
        let announcementUpdate = persistedLocalStore.announcementUpdate

        let { data } = await this.$axiosInstance.get(
          '/Disclaimer/Announcement',
          {
            params: {
              disablePaging: true,
            },
          }
        )

        let announcements = data?.data?.items
        if (announcements?.length) {
          this.setState({
            key: 'announcements',
            value: announcements,
          })

          if (persistedStore.currentLocationId) {
            let hasUnReadAnnouncement = false
            if (!Object.keys(announcementUpdate).length) {
              hasUnReadAnnouncement = true
            } else
              announcements.every((announcement) => {
                if (
                  !announcementUpdate?.hasOwnProperty(announcement.id) ||
                  (announcementUpdate?.hasOwnProperty(announcement.id) &&
                    announcementUpdate[announcement.id] !=
                      announcement.updatedAt)
                ) {
                  hasUnReadAnnouncement = true
                  return false
                }

                return true
              })

            if (hasUnReadAnnouncement) {
              let parentDialog = this.showCaseStore.getDialogState(
                'DisclaimerDialog'
              )
                ? 'DisclaimerDialog'
                : null
              showCaseStore.updateDialogState({
                dialog: 'AnnouncementDialog',
                val: false,
                parentDialog,
              })

              showCaseStore.setDialogProperties({
                dialog: 'AnnouncementDialog',
                properties: {
                  showUnread: true,
                },
                refresh: true,
              })
            }
          }
        }
        return data
      } catch (error) {
        return error
      }
    },
    async getPaymentServiceLogos() {
      try {
        let { data } = await this.$axiosInstance.get(
          '/FooterDetails/PaymentLogos'
        )
        if (data?.data) {
          this.setState({ key: 'paymentServiceLogos', value: data.data })
        }
      } catch (error) {}
    },
    async requestOtp(otpRequestData) {
      try {
        const response = await this.$axiosInstance.post(
          'v1/Customer/CustomerInquiry/Otp',
          otpRequestData
        )
        return response.data
      } catch (error) {
        if (error?.errors && error?.errors[0]?.errorCode === 'CUST_0006') {
          NotifyMethods.showError(
            'An error occurred while requesting OTP. Please try again later.'
          )
        } else {
          NotifyMethods.showError('An error occurred. Please try again later.')
        }
        return false
      }
    },
    async submitCustomerInquiry(inquiryData) {
      try {
        const response = await this.$axiosInstance.post(
          'v1/Customer/CustomerInquiry',
          inquiryData
        )
        return response.data
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again later.'

        if (error?.errors) {
          const otpError = error.errors.find(
            (err) =>
              err.errorCode === 'OTP_0002' ||
              err.errorCode === 'OTP_0003' ||
              err.errorCode === 'OTP_ATTEMPTS_EXCEEDED'
          )

          if (otpError) {
            if (otpError.errorCode === 'OTP_0002') {
              return { success: false, otpClear: true }
            } else if (otpError.errorCode === 'OTP_ATTEMPTS_EXCEEDED') {
              return { success: false, otpAttemptsExceeded: true }
            }
            errorMessage = otpError.descreption
          }
        }

        NotifyMethods.showError(errorMessage)
        return false
      }
    },
    getPolicyDetails() {
      try {
        this.$axiosInstance
          .get('/Configuration/PolicyDetail')
          .then((response) => {
            if (response?.data?.data)
              this.setState({ key: 'policyData', value: response.data.data })
          })
      } catch (error) {}
    },
    async getEmailVerificationOTP(body) {
      try {
        let { data } = await this.$axiosInstance.post(
          'v1/Cart/NotifyMe/Otp',
          body
        )
        return data
      } catch (error) {
        return error
      }
    },
    //For Different Actions
    setState({ key, value }) {
      this[key] = value
    },
    setFrequentSearches(arrSearches) {
      arrSearches.map((key) => this.frequentSearches.push(key))
    },
    setTrendingProducts(trendingProducts) {
      this.trendingProducts = Object.assign({}, trendingProducts)
    },
    setHeader(properties) {
      this.headerInfo = Object.assign({}, properties)
    },
    resetHeader() {
      this.headerInfo = Object.assign({})
    },
    setHeaderTitle({ title, params = {} }) {
      let properties = {
        accountButton: true,
        searchButton: true,
        cartButton: true,
        backButton: true,
        homeButtom: true,
        logo: false,
        categoryButton: false,
        ...params,
      }

      if (title) properties.title = title

      this.headerInfo = Object.assign({}, { ...this.headerInfo }, properties)
    },
    addInHistory(history) {
      this.backHistories.push(history)
    },
    clearHistory() {
      this.backHistories.splice(0)
    },
    popFromHistory() {
      this.backHistories.pop()
    },
    setLocationFulfillments({ fulfillments }) {
      if (fulfillments) this.fulFillmentLocations = fulfillments
    },
    updateState({ key, val }) {
      this[key] = val
    },

    //setState is Used for
    //1) SET_APP_LOADED
    //2)SET_FIRST_LOADED
    //3)SET_BUSINESS_CONFIGURATIONS
    //4)SET_NETWORK_STATUS
    //5)SET_FOOTER_DATA
    //6)SET_SOCIAL_PLATFORMS
    //7)SET_STORE_CONFIGURATION_LOADED
    //8)SET_TENANT_FOUND
    //9)SET_STORE_IS_ACTIVE
    //10)SET_MOBILE_APP_DATA
    //11)SET_BUSINESS_FULFILLMENTS
    //12)SET_ALL_FULFILLMENT
    //13)SET_FULFILLMENT_INACTIVE
    //14)SET_ASK_ADDRESS_FOR_DELIVERY
    //15)SET_PAYMENT_SERVICES_LOGO_LOADED
    //16)SET_PAYMENT_SERVICES_LOGO
  },
})
